import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AppConfig, LayoutService } from './layout/service/app.layout.service';
import { ConfigUtils } from './utils/config.utils';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    private appConfig: AppConfig;

    constructor(private primengConfig: PrimeNGConfig, private layoutService: LayoutService) {
        this.appConfig = ConfigUtils.getDefaultAppConfig()
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.layoutService.config.set(this.appConfig);
    }
}
